export default {
    getAssessmentRubricById: '/assessmentRubric/getAssessmentRubricById'
}
